/**
 * Account deletion sheet (global menu) — BaseModal tuning.
 */

export const PRIVACY_ACCOUNT_DELETION_MODAL = {
  BASE_MODAL_BLUR_INTENSITY: 22,
} as const;

export const PRIVACY_ACCOUNT_DELETION_MODAL_TEST_ID = 'privacy-account-deletion-modal';
export const PRIVACY_ACCOUNT_DELETION_MODAL_CONTENT_TEST_ID =
  'privacy-account-deletion-modal-content';
